/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */
 <template>
  <div>
    <div
      style="text-align: justify; text-justify: inter-word"
    >
      <p style="text-align: center"><b>RECEITUÁRIO AGRONÔMICO</b></p>
      <header class="header mt-1">
        <div class="mt-1 w-50">
          <img
            v-if="empresa.logo != undefined"
            class="logo"
            :src="`data:image/png;base64, ${empresa.logo}`"
          />
          <p>
            <b>Receita Nº:</b> {{ receita.ultimaReceitaEmitida }} /
            <b>ART N°:</b> {{ receita.artVinculada }}</p
          >
          <p
            v-if="
              receita.artImpressao !== null && receita.artImpressao.length > 0
            "
          >
            <b>CFTA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
          <p v-else>
            <b>CREA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
        </div>
        <div class="mt-1">
          <p>
            <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }}
          </p>
          <p>
            <b>Endereço:</b> {{ receita.enderecoEmpresa }}
            {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}</p
          >
        </div>
      </header>
      <div class="dashed-box mt-3">
        <h2><b>IDENTIFICAÇÃO AGRICULTOR</b></h2>
        <div class="mt-2 w-100">
          <p>
            <b>Cliente:</b> {{ receita.nomeProdutor }} - <b>CPF/CNPJ:</b
            >{{ receita.cpfCnpjProdutor }} - <b>Inscrição produtor:</b
            >{{ receita.inscricaoEstadualProdutor }}</p
          >
          <p>
            <b>Endereço/Município: </b>{{ receita.endereco }} /
            {{ receita.municipio }} - {{ receita.estado }} / <b>Telefone:</b
            >{{ receita.telefone }}
          </p>
          <!-- <p> <b>Local de aplicação:</b>{{ receita.localAplicacao }} </p> -->
        </div>
      </div>
      <div v-for="item in receita.itens.slice(0, 2)" :key="item.idReceitaItem">
        <div class="dashed-box mt-2 mb-3">
          <h2><b>DIAGNÓSTICO</b></h2>
          <div class="row w-100">
            <div class="col-7"
              ><div class="mt-2">
                <p>
                  <b>Cultura:</b> {{ item.nomeComumCultura }}
                  {{ item.nomeCientificoCultura }} - <b>Estágio:</b>
                  {{ item.descEpocaAplicCultura }}
                </p>
                <p>
                  <b>Diagnóstico:</b> {{ item.nomeComumAlvo }}
                  {{ item.nomeCientificoAlvo }} - <b>Estágio:</b>
                  {{ item.descEpocaAplicPraga }}
                </p>
                <div v-if="receita.estado.includes('Ceará')">
                  <p>
                    <b>Produto:</b> {{ item.nomeProduto }} ({{
                      item.ingredienteAtivo.join(' ')
                    }})<br />

                    <b>Fabricante:</b> {{ item.fabricante }}<br />
                    <b>Formulação:</b> {{ item.formulacao }}
                    <b>Grupo Químico:</b>
                    {{ item.grupoQuimico }}
                    <b>Local aplicação:</b> {{ item.localAplicacao }} /
                    <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }}

                    <!-- <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
                <span v-if="item.volumeCalda > 0"
                  ><b>- Calda:</b> {{ item.volumeCalda }}
                  {{ item.unidadeCalda }}</span
                > -->
                  </p>
                </div>
                <div v-else>
                  <p>
                    <b>Produto:</b> {{ item.nomeProduto }} ({{
                      item.ingredienteAtivo.join(' ')
                    }})</p
                  >
                  <p>
                    <b>Local aplicação:</b> {{ item.localAplicacao }} /
                    <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="col-5"
              style="padding: 0 !important; margin: 0 !important"
            >
              <div class="mt-2">
                <p>
                  <b>Classe Toxicológica:</b>
                  {{ item.classeToxicologicaProduto }}
                </p>
                <p>
                  <b>Intervalo de Segurança:</b>
                  {{ item.intervaloSeguranca }} dias / <b>Nº de aplicações:</b>
                  {{ item.nAplicacoes }}
                </p>
                <p> <b>Quantidade a adquirir:</b> {{ item.qtdeAdquirir }} {{ item.unidade ?  item.unidade : ''}}</p>
                <p>
                  <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
                  <span v-if="item.volumeCalda > 0"
                    ><b>- Calda:</b> {{ item.volumeCalda }}
                    {{ item.unidadeCalda }}</span
                  >
                  <b> - Área (ha):</b> {{ item.areaAplicacao }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: -13px">
          <p>
            <b>Modo / Época de aplicação</b>
            {{ item.descModoAplicacao }}
          </p>
        </div>
        <div>
          <p>
            <b>Equipamento de Proteção Individual (EPI) USO OBRIGATÓRIO</b>
            {{ item.descEpi }}
          </p>
        </div>
        <div>
          <p>
            <b>Precauções de Uso</b>
            {{ item.descPrecaucaoUso }}
          </p>
        </div>
        <div v-if="item.obs">
          <p>
            <b>OBSERVAÇÕES</b>
            {{ item.obs }}
          </p>
        </div>
      </div>
      <div class="dashed-box mt-3">
        <h2
          ><b
            >ORIENTAÇÕES QUANTO AO MANEJO INTEGRADO DE PRAGAS E DE
            RESISTÊNCIA</b
          ></h2
        >
        <p class="mt-3">
          Realizar o manejo integrado de pragas e resistência. Adotar medidas
          favoráveis que visem a redução ou o controle populacional do problema
          fitossanitário compondo um programa de manejo integrado
        </p>
      </div>
      <div class="dashed-box mt-3">
        <h2><b>DESTINAÇÃO FINAL DOS RESÍDUOS E EMBALAGENS VAZIAS</b></h2>
        <p class="mt-2">
          É proibido reutilizar as embalagens de agrotóxicos e afins. As
          embalagens rígidas que contiverem formulações miscíveis ou
          dispersíveis em água deverão ser submetidas pelo usuário à operação de
          tríplice lavagem, ou tecnologia equivalente, conforme normas técnicas
          oriundas dos órgãos competentes e orientação constante de seus rótulos
          e bulas. Os usuários deverão efetuar a devolução das embalagens vazias
          em postos ou centros de recolhimentos, de acordo com as instruções
          previstas nas respectivas bulas, no prazo de até um ano, contado da
          data de compra. (Lei n. 9.974/00, Decreto Federal n.° 4.074/02). </p
        ><b>Local para entrega das embalagens:</b>
        {{
          configuracao.frase_unidade_recebimento == undefined ||
          configuracao.frase_unidade_recebimento.length == 0
            ? receita.unidRecebimento
            : configuracao.frase_unidade_recebimento
        }}
      </div>
      <footer class="footer-receita mt-3" v-show="empresa.id_empresa_sistema !== 50">
        <h2
          >LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO É
          VENENO.</h2
        >
        <div class="card">
          <p>
            <b style="font-size: 10px"
              >Estou ciente das informações contidas nesta receita e seu
              anexo.</b
            >
          </p>
          <div class="assinatura mt-4">
            <p>
              <b>{{ receita.nomeProdutor }}</b>
            </p>
          </div>
          <div class="card-footer-receita mt-2 mb-2">
            <div>
              <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
              <p>
                <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                <b>Cidade/UF:</b> {{ receita.municipio }} /
                {{ receita.estado }}
              </p>
            </div>
          </div>
        </div>

        <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
          <div v-show="isSignature">
            <img
              v-if="checkBase64()"
              height="40"
              :src="receita.assinatura"
              alt="assinatura"
            />
            <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
          </div>

          <div class="assinatura mt-4 pt-2">
            <p>{{ receita.nomeAgronomo }}</p>
          </div>
          <div class="card-footer-receita mt-2 mb-2">
            <div>
              <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
              <p>
                <b>CPF:</b>{{ receita.cpf }}
                <span
                  v-if="
                    receita.artImpressao !== null &&
                    receita.artImpressao.length > 0
                  "
                >
                  <b>CFTA:</b>{{ receita.crea }}
                </span>
                <span v-else> <b>CREA:</b>{{ receita.crea }} </span> </p
              ><p> </p>
            </div>
          </div>
        </div>
      </footer>
      <div class="html2pdf__page-break"></div>

      <p style="text-align: center"><b>RECEITUÁRIO AGRONÔMICO</b></p>
      <header class="header mt-1">
        <div class="mt-1">
          <img
            v-if="empresa.logo != undefined"
            class="logo"
            :src="`data:image/png;base64, ${empresa.logo}`"
          />
          <p> <b>Receita Nº:</b> {{ receita.ultimaReceitaEmitida }} </p>
          <p
            v-if="
              receita.artImpressao !== null && receita.artImpressao.length > 0
            "
          >
            <b>CFTA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
          <p v-else>
            <b>CREA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}</p
          >
        </div>
        <div class="mt-1">
          <p>
            <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }}
          </p>
          <p>
            <b>Endereço:</b> {{ receita.enderecoEmpresa }}
            {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}</p
          >
        </div>
      </header>
      <div class="dashed-box mt-3">
        <h2><b>IDENTIFICAÇÃO AGRICULTOR</b></h2>
        <div class="mt-2 w-100">
          <p>
            <b>Cliente:</b> {{ receita.nomeProdutor }} - <b>CPF/CNPJ:</b
            >{{ receita.cpfCnpjProdutor }} - <b>Inscrição produtor:</b
            >{{ receita.inscricaoEstadualProdutor }}</p
          >
          <p>
            <b>Endereço/Município: </b>{{ receita.endereco }} /
            {{ receita.municipio }} - {{ receita.estado }} / <b>Telefone:</b
            >{{ receita.telefone }}
          </p>
          <!-- <p> <b>Local de aplicação:</b>{{ receita.localAplicacao }} </p> -->
        </div>
      </div>
      <div v-for="item in receita.itens.slice(2, 4)" :key="item.idReceitaItem">
        <div class="dashed-box mt-2 mb-3">
          <h2><b>DIAGNÓSTICO</b></h2>
          <div class="mt-2">
            <p>
              <b>Cultura:</b> {{ item.nomeComumCultura }}
              {{ item.nomeCientificoCultura }} - <b>Estágio:</b>
              {{ item.descEpocaAplicCultura }}
            </p>
            <p>
              <b>Diagnóstico:</b> {{ item.nomeComumAlvo }}
              {{ item.nomeCientificoAlvo }} - <b>Estágio:</b>
              {{ item.descEpocaAplicPraga }}
            </p>
            <div v-if="receita.estado.includes('Ceará')">
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})<br />

                <b>Fabricante:</b> {{ item.fabricante }}<br />
                <b>Formulação:</b> {{ item.formulacao }} <b>Grupo Químico:</b>
                {{ item.grupoQuimico }}

                <b>Quantidade a adquirir:</b> {{ item.qtdeAdquirir }}<br />

                <b>Local aplicação:</b> {{ item.localAplicacao }} /
                <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }}

                <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
                <span v-if="item.volumeCalda > 0"
                  ><b>- Calda:</b> {{ item.volumeCalda }}
                  {{ item.unidadeCalda }}</span
                >
              </p>
            </div>
            <div v-else>
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})</p
              >
              <p> <b>Quantidade a adquirir:</b> {{ item.qtdeAdquirir }} {{ item.unidade ?  item.unidade : ''}}</p>
              <p>
                <b>Local aplicação:</b> {{ item.localAplicacao }} /
                <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }}
              </p>
              <p>
                <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
                <span v-if="item.volumeCalda > 0"
                  ><b>- Calda:</b> {{ item.volumeCalda }}
                  {{ item.unidadeCalda }}</span
                >
              </p>
            </div>
          </div>
          <div class="mt-2">
            <p>
              <b>Classe Toxicológica:</b>
              {{ item.classeToxicologicaProduto }}
            </p>
            <p> <b>Número de aplicações:</b> {{ item.nAplicacoes }} </p>
            <p>
              <b>Intervalo de Segurança:</b>
              {{ item.intervaloSeguranca }} dias
            </p>
            <p> <b>Área (ha):</b> {{ item.areaAplicacao }} </p>
          </div>
        </div>
        <div style="margin-top: -12px">
          <p>
            <b>Modo / Época de aplicação</b>
            {{ item.descModoAplicacao }}
          </p>
        </div>
        <div>
          <p>
            <b>Equipamento de Proteção Individual (EPI) USO OBRIGATÓRIO</b>
            {{ item.descEpi }}
          </p>
        </div>
        <div>
          <p>
            <b>Precauções de Uso</b>
            {{ item.descPrecaucaoUso }}
          </p>
        </div>
        <div v-if="item.obs">
          <p>
            <b>OBSERVAÇÕES</b>
            {{ item.obs }}
          </p>
        </div>
      </div>
      <div class="dashed-box mt-3">
        <h2
          ><b
            >ORIENTAÇÕES QUANTO AO MANEJO INTEGRADO DE PRAGAS E DE
            RESISTÊNCIA</b
          ></h2
        >
        <p class="mt-3">
          Realizar o manejo integrado de pragas e resistência. Adotar medidas
          favoráveis que visem a redução ou o controle populacional do problema
          fitossanitário compondo um programa de manejo integrado
        </p>
      </div>
      <div class="dashed-box mt-3">
        <h2><b>DESTINAÇÃO FINAL DOS RESÍDUOS E EMBALAGENS VAZIAS</b></h2>
        <p class="mt-2">
          É proibido reutilizar as embalagens de agrotóxicos e afins. As
          embalagens rígidas que contiverem formulações miscíveis ou
          dispersíveis em água deverão ser submetidas pelo usuário à operação de
          tríplice lavagem, ou tecnologia equivalente, conforme normas técnicas
          oriundas dos órgãos competentes e orientação constante de seus rótulos
          e bulas. Os usuários deverão efetuar a devolução das embalagens vazias
          em postos ou centros de recolhimentos, de acordo com as instruções
          previstas nas respectivas bulas, no prazo de até um ano, contado da
          data de compra. (Lei n. 9.974/00, Decreto Federal n.° 4.074/02). </p
        ><b>Local para entrega das embalagens:</b>
        {{
          configuracao.frase_unidade_recebimento == undefined ||
          configuracao.frase_unidade_recebimento.length == 0
            ? receita.unidRecebimento
            : configuracao.frase_unidade_recebimento
        }}
      </div>
      <footer class="footer-receita mt-3" v-show="empresa.id_empresa_sistema !== 50">
        <h2
          >LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO É
          VENENO.</h2
        >
        <div
          class="card"
          :style="receita.is_sign_produtor ? 'display:none;' : 'display:block;'"
        >
          <p>
            <b style="font-size: 10px"
              >Estou ciente das informações contidas nesta receita e seu
              anexo.</b
            >
          </p>
          <div class="assinatura mt-4 pt-2">
            <p>
              {{ receita.nomeProdutor }}
            </p>
          </div>
          <div class="card-footer-receita mt-2 mb-2">
            <div>
              <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
              <p>
                <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                <b>Cidade/UF:</b> {{ receita.municipio }} /
                {{ receita.estado }}
              </p>
            </div>
          </div>
        </div>

        <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
          <div v-show="isSignature">
            <img
              v-if="checkBase64()"
              height="40"
              :src="receita.assinatura"
              alt="assinatura"
            />
            <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
          </div>

          <div class="assinatura mt-4 pt-2">
            <p>{{ receita.nomeAgronomo }}</p>
          </div>
          <div class="card-footer-receita mt-2 mb-2">
            <div>
              <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
              <p>
                <b>CPF:</b>{{ receita.cpf }}
                <span
                  v-if="
                    receita.artImpressao !== null &&
                    receita.artImpressao.length > 0
                  "
                >
                  <b>CFTA:</b>{{ receita.crea }}
                </span>
                <span v-else> <b>CREA:</b>{{ receita.crea }} </span> </p
              ><p> </p>
            </div>
          </div>
        </div>
      </footer>
      <div class="html2pdf__page-break"></div>

      <p style="text-align: center"><b>RECEITUÁRIO AGRONÔMICO</b></p>
      <header class="header mt-1">
        <div class="mt-1">
          <img
            v-if="empresa.logo != undefined"
            class="logo"
            :src="`data:image/png;base64, ${empresa.logo}`"
          />
          <p> <b>Receita Nº:</b> {{ receita.ultimaReceitaEmitida }} </p>
          <p
            v-if="
              receita.artImpressao !== null && receita.artImpressao.length > 0
            "
          >
            <b>CFTA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
          <p v-else>
            <b>CREA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}</p
          >
        </div>
        <div class="mt-1">
          <p>
            <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }}
          </p>
          <p>
            <b>Endereço:</b> {{ receita.enderecoEmpresa }}
            {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}</p
          >
        </div>
      </header>
      <div class="dashed-box mt-3">
        <h2><b>IDENTIFICAÇÃO AGRICULTOR</b></h2>
        <div class="mt-2 w-100">
          <p>
            <b>Cliente:</b> {{ receita.nomeProdutor }} - <b>CPF/CNPJ:</b
            >{{ receita.cpfCnpjProdutor }} - <b>Inscrição produtor:</b
            >{{ receita.inscricaoEstadualProdutor }}</p
          >
          <p>
            <b>Endereço/Município: </b>{{ receita.endereco }} /
            {{ receita.municipio }} - {{ receita.estado }} / <b>Telefone:</b
            >{{ receita.telefone }}
          </p>
          <!-- <p> <b>Local de aplicação:</b>{{ receita.localAplicacao }} </p> -->
        </div>
      </div>
      <div v-for="item in receita.itens.slice(4, 6)" :key="item.idReceitaItem">
        <div class="dashed-box mt-2 mb-3">
          <h2><b>DIAGNÓSTICO</b></h2>
          <div class="mt-2">
            <p>
              <b>Cultura:</b> {{ item.nomeComumCultura }}
              {{ item.nomeCientificoCultura }} - <b>Estágio:</b>
              {{ item.descEpocaAplicCultura }}
            </p>
            <p>
              <b>Diagnóstico:</b> {{ item.nomeComumAlvo }}
              {{ item.nomeCientificoAlvo }} - <b>Estágio:</b>
              {{ item.descEpocaAplicPraga }}
            </p>
            <div v-if="receita.estado.includes('Ceará')">
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})<br />

                <b>Fabricante:</b> {{ item.fabricante }}<br />
                <b>Formulação:</b> {{ item.formulacao }} <b>Grupo Químico:</b>
                {{ item.grupoQuimico }}

                <b>Quantidade a adquirir:</b> {{ item.qtdeAdquirir }}<br />

                <b>Local aplicação:</b> {{ item.localAplicacao }} /
                <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }}

                <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
                <span v-if="item.volumeCalda > 0"
                  ><b>- Calda:</b> {{ item.volumeCalda }}
                  {{ item.unidadeCalda }}</span
                >
              </p>
            </div>
            <div v-else>
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})</p
              >
              <p> <b>Quantidade a adquirir:</b> {{ item.qtdeAdquirir }} {{ item.unidade ?  item.unidade : ''}}</p>
              <p>
                <b>Local aplicação:</b> {{ item.localAplicacao }} /
                <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }}
              </p>
              <p>
                <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
                <span v-if="item.volumeCalda > 0"
                  ><b>- Calda:</b> {{ item.volumeCalda }}
                  {{ item.unidadeCalda }}</span
                >
              </p>
            </div>
          </div>
          <div class="mt-2">
            <p>
              <b>Classe Toxicológica:</b>
              {{ item.classeToxicologicaProduto }}
            </p>
            <p> <b>Número de aplicações:</b> {{ item.nAplicacoes }} </p>
            <p>
              <b>Intervalo de Segurança:</b>
              {{ item.intervaloSeguranca }} dias
            </p>
            <p> <b>Área (ha):</b> {{ item.areaAplicacao }} </p>
          </div>
        </div>
        <div style="margin-top: -12px">
          <p>
            <b>Modo / Época de aplicação</b>
            {{ item.descModoAplicacao }}
          </p>
        </div>
        <div>
          <p>
            <b>Equipamento de Proteção Individual (EPI) USO OBRIGATÓRIO</b>
            {{ item.descEpi }}
          </p>
        </div>
        <div>
          <p>
            <b>Precauções de Uso</b>
            {{ item.descPrecaucaoUso }}
          </p>
        </div>
        <div v-if="item.obs">
          <p>
            <b>OBSERVAÇÕES</b>
            {{ item.obs }}
          </p>
        </div>
      </div>
      <div class="dashed-box mt-3">
        <h2
          ><b
            >ORIENTAÇÕES QUANTO AO MANEJO INTEGRADO DE PRAGAS E DE
            RESISTÊNCIA</b
          ></h2
        >
        <p class="mt-3">
          Realizar o manejo integrado de pragas e resistência. Adotar medidas
          favoráveis que visem a redução ou o controle populacional do problema
          fitossanitário compondo um programa de manejo integrado
        </p>
      </div>
      <div class="dashed-box mt-3">
        <h2><b>DESTINAÇÃO FINAL DOS RESÍDUOS E EMBALAGENS VAZIAS</b></h2>
        <p class="mt-2">
          É proibido reutilizar as embalagens de agrotóxicos e afins. As
          embalagens rígidas que contiverem formulações miscíveis ou
          dispersíveis em água deverão ser submetidas pelo usuário à operação de
          tríplice lavagem, ou tecnologia equivalente, conforme normas técnicas
          oriundas dos órgãos competentes e orientação constante de seus rótulos
          e bulas. Os usuários deverão efetuar a devolução das embalagens vazias
          em postos ou centros de recolhimentos, de acordo com as instruções
          previstas nas respectivas bulas, no prazo de até um ano, contado da
          data de compra. (Lei n. 9.974/00, Decreto Federal n.° 4.074/02). </p
        ><b>Local para entrega das embalagens:</b>
        {{
          configuracao.frase_unidade_recebimento == undefined ||
          configuracao.frase_unidade_recebimento.length == 0
            ? receita.unidRecebimento
            : configuracao.frase_unidade_recebimento
        }}
      </div>
      <footer class="footer-receita mt-3" v-show="empresa.id_empresa_sistema !== 50">
        <h2
          >LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO É
          VENENO.</h2
        >
        <div
          class="card"
          :style="receita.is_sign_produtor ? 'display:none;' : 'display:block;'"
        >
          <p>
            <b style="font-size: 10px"
              >Estou ciente das informações contidas nesta receita e seu
              anexo.</b
            >
          </p>
          <div class="assinatura mt-4 pt-2">
            <p>
              {{ receita.nomeProdutor }}
            </p>
          </div>
          <div class="card-footer-receita mt-2 mb-2">
            <div>
              <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
              <p>
                <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                <b>Cidade/UF:</b> {{ receita.municipio }} /
                {{ receita.estado }}
              </p>
            </div>
          </div>
        </div>

        <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
          <div v-show="isSignature">
            <img
              v-if="checkBase64()"
              height="40"
              :src="receita.assinatura"
              alt="assinatura"
            />
            <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
          </div>

          <div class="assinatura mt-4 pt-2">
            <p>{{ receita.nomeAgronomo }}</p>
          </div>
          <div class="card-footer-receita mt-2 mb-2">
            <div>
              <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
              <p>
                <b>CPF:</b>{{ receita.cpf }}
                <span
                  v-if="
                    receita.artImpressao !== null &&
                    receita.artImpressao.length > 0
                  "
                >
                  <b>CFTA:</b>{{ receita.crea }}
                </span>
                <span v-else> <b>CREA:</b>{{ receita.crea }} </span> </p
              ><p> </p>
            </div>
          </div>
        </div>
      </footer>
      <div class="html2pdf__page-break"></div>

      <p style="text-align: center"><b>RECEITUÁRIO AGRONÔMICO</b></p>
      <header class="header mt-1">
        <div class="mt-1">
          <img
            v-if="empresa.logo != undefined"
            class="logo"
            :src="`data:image/png;base64, ${empresa.logo}`"
          />
          <p> <b>Receita Nº:</b> {{ receita.ultimaReceitaEmitida }} </p>
          <p
            v-if="
              receita.artImpressao !== null && receita.artImpressao.length > 0
            "
          >
            <b>CFTA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}
          </p>
          <p v-else>
            <b>CREA:</b>{{ receita.crea }} <b>Data:</b>
            {{ formatDate(receita.dataEmissao) }} <b>N.F:</b>{{ receita.nf }}</p
          >
        </div>
        <div class="mt-1">
          <p>
            <b>{{ receita.profissao }}:</b> {{ receita.nomeAgronomo }}
          </p>
          <p>
            <b>Endereço:</b> {{ receita.enderecoEmpresa }}
            {{ receita.municipioEmpresa }} - {{ receita.estadoEmpresa }}</p
          >
        </div>
      </header>
      <div class="dashed-box mt-3">
        <h2><b>IDENTIFICAÇÃO AGRICULTOR</b></h2>
        <div class="mt-2 w-100">
          <p>
            <b>Cliente:</b> {{ receita.nomeProdutor }} - <b>CPF/CNPJ:</b
            >{{ receita.cpfCnpjProdutor }} - <b>Inscrição produtor:</b
            >{{ receita.inscricaoEstadualProdutor }}</p
          >
          <p>
            <b>Endereço/Município: </b>{{ receita.endereco }} /
            {{ receita.municipio }} - {{ receita.estado }} / <b>Telefone:</b
            >{{ receita.telefone }}
          </p>
          <!-- <p> <b>Local de aplicação:</b>{{ receita.localAplicacao }} </p> -->
        </div>
      </div>
      <div v-for="item in receita.itens.slice(6, 8)" :key="item.idReceitaItem">
        <div class="dashed-box mt-2 mb-3">
          <h2><b>DIAGNÓSTICO</b></h2>
          <div class="mt-2">
            <p>
              <b>Cultura:</b> {{ item.nomeComumCultura }}
              {{ item.nomeCientificoCultura }} - <b>Estágio:</b>
              {{ item.descEpocaAplicCultura }}
            </p>
            <p>
              <b>Diagnóstico:</b> {{ item.nomeComumAlvo }}
              {{ item.nomeCientificoAlvo }} - <b>Estágio:</b>
              {{ item.descEpocaAplicPraga }}
            </p>
            <div v-if="receita.estado.includes('Ceará')">
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})<br />

                <b>Fabricante:</b> {{ item.fabricante }}<br />
                <b>Formulação:</b> {{ item.formulacao }} <b>Grupo Químico:</b>
                {{ item.grupoQuimico }}

                <b>Quantidade a adquirir:</b> {{ item.qtdeAdquirir }} {{ item.unidade ?  item.unidade : ''}}<br />

                <b>Local aplicação:</b> {{ item.localAplicacao }} /
                <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }}

                <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
                <span v-if="item.volumeCalda > 0"
                  ><b>- Calda:</b> {{ item.volumeCalda }}
                  {{ item.unidadeCalda }}</span
                >
              </p>
            </div>
            <div v-else>
              <p>
                <b>Produto:</b> {{ item.nomeProduto }} ({{
                  item.ingredienteAtivo.join(' ')
                }})</p
              >
              <p> <b>Quantidade a adquirir:</b> {{ item.qtdeAdquirir }} </p>
              <p>
                <b>Local aplicação:</b> {{ item.localAplicacao }} /
                <b>Modalidade de Aplicação:</b> {{ item.tipoAplicacao }}
              </p>
              <p>
                <b>Dose:</b> {{ item.dose }} {{ item.unidadeDose }}
                <span v-if="item.volumeCalda > 0"
                  ><b>- Calda:</b> {{ item.volumeCalda }}
                  {{ item.unidadeCalda }}</span
                >
              </p>
            </div>
          </div>
          <div class="mt-2">
            <p>
              <b>Classe Toxicológica:</b>
              {{ item.classeToxicologicaProduto }}
            </p>
            <p> <b>Número de aplicações:</b> {{ item.nAplicacoes }} </p>
            <p>
              <b>Intervalo de Segurança:</b>
              {{ item.intervaloSeguranca }} dias
            </p>
            <p> <b>Área (ha):</b> {{ item.areaAplicacao }} </p>
          </div>
        </div>
        <div style="margin-top: -12px">
          <p>
            <b>Modo / Época de aplicação</b>
            {{ item.descModoAplicacao }}
          </p>
        </div>
        <div>
          <p>
            <b>Equipamento de Proteção Individual (EPI) USO OBRIGATÓRIO</b>
            {{ item.descEpi }}
          </p>
        </div>
        <div>
          <p>
            <b>Precauções de Uso</b>
            {{ item.descPrecaucaoUso }}
          </p>
        </div>
        <div v-if="item.obs">
          <p>
            <b>OBSERVAÇÕES</b>
            {{ item.obs }}
          </p>
        </div>
      </div>
      <div class="dashed-box mt-3">
        <h2
          ><b
            >ORIENTAÇÕES QUANTO AO MANEJO INTEGRADO DE PRAGAS E DE
            RESISTÊNCIA</b
          ></h2
        >
        <p class="mt-3">
          Realizar o manejo integrado de pragas e resistência. Adotar medidas
          favoráveis que visem a redução ou o controle populacional do problema
          fitossanitário compondo um programa de manejo integrado
        </p>
      </div>
      <div class="dashed-box mt-3">
        <h2><b>DESTINAÇÃO FINAL DOS RESÍDUOS E EMBALAGENS VAZIAS</b></h2>
        <p class="mt-2">
          É proibido reutilizar as embalagens de agrotóxicos e afins. As
          embalagens rígidas que contiverem formulações miscíveis ou
          dispersíveis em água deverão ser submetidas pelo usuário à operação de
          tríplice lavagem, ou tecnologia equivalente, conforme normas técnicas
          oriundas dos órgãos competentes e orientação constante de seus rótulos
          e bulas. Os usuários deverão efetuar a devolução das embalagens vazias
          em postos ou centros de recolhimentos, de acordo com as instruções
          previstas nas respectivas bulas, no prazo de até um ano, contado da
          data de compra. (Lei n. 9.974/00, Decreto Federal n.° 4.074/02). </p
        ><b>Local para entrega das embalagens:</b>
        {{
          configuracao.frase_unidade_recebimento == undefined ||
          configuracao.frase_unidade_recebimento.length == 0
            ? receita.unidRecebimento
            : configuracao.frase_unidade_recebimento
        }}
      </div>
      <footer class="footer-receita mt-3" v-show="empresa.id_empresa_sistema !== 50">
        <h2
          >LEIA ATENTAMENTE O RÓTULO E BULA DO PRODUTO. AGRICULTOR, AGROTÓXICO É
          VENENO.</h2
        >
        <div
          class="card"
          :style="receita.is_sign_produtor ? 'display:none;' : 'display:block;'"
        >
          <p>
            <b style="font-size: 10px"
              >Estou ciente das informações contidas nesta receita e seu
              anexo.</b
            >
          </p>
          <div class="assinatura mt-4 pt-2">
            <p>
              {{ receita.nomeProdutor }}
            </p>
          </div>
          <div class="card-footer-receita mt-2 mb-2">
            <div>
              <p> <b>CPF/CNPJ: </b>{{ receita.cpfCnpjProdutor }} </p>
              <p>
                <b>Data:</b> {{ formatDate(receita.dataEmissao) }} /
                <b>Cidade/UF:</b> {{ receita.municipio }} /
                {{ receita.estado }}
              </p>
            </div>
          </div>
        </div>

        <div :class="receita.is_sign_produtor ? 'card col-6' : 'card'">
          <div v-show="isSignature">
            <img
              v-if="checkBase64()"
              height="40"
              :src="receita.assinatura"
              alt="assinatura"
            />
            <label v-else class="sig3 mt-2">{{ receita.assinatura }}</label>
          </div>

          <div class="assinatura mt-4 pt-2">
            <p>{{ receita.nomeAgronomo }}</p>
          </div>
          <div class="card-footer-receita mt-2 mb-2">
            <div>
              <p> <b>Título do profissional:</b> {{ receita.profissao }} </p>
              <p>
                <b>CPF:</b>{{ receita.cpf }}
                <span
                  v-if="
                    receita.artImpressao !== null &&
                    receita.artImpressao.length > 0
                  "
                >
                  <b>CFTA:</b>{{ receita.crea }}
                </span>
                <span v-else> <b>CREA:</b>{{ receita.crea }} </span> </p
              ><p> </p>
            </div>
          </div>
        </div>
      </footer>
      <div class="html2pdf__page-break"></div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
moment.locale('pt-br')

export default {
  components: {},
  props: {
    receita: {},
    empresa: {},
    isSignature: false,
  },
  data() {
    return {
      configuracao: {},
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.configuracao = JSON.parse(window.localStorage.getItem('configuracao'))
  },
  computed: {},
  methods: {
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
    checkBase64() {
      if (this.receita.assinatura != undefined) {
        var base64regex =
          /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/

        return base64regex.test(
          this.receita.assinatura.replace('data:image/png;base64,', '')
        )
      }
      return false
    },
  },
}
</script>

<style scoped>
body {
  width: 1240px;
  height: 1754px;
  margin: auto;
  font-size: 1em;
  font-family: sans-serif;
}

.logo {
  text-align: left;
  color: #bbb;
}

.logo {
  width: 120px;
  margin: 0;
}

.container {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
}

.container div {
  padding: 5px 0;
}

.header-page2 {
  display: flex;
  padding: 0px 0;
}

.header-page2 div {
  border: 2px solid #000;
  padding: 5px 5px 5px 5px;
}

.header-page2 div:nth-of-type(1) {
  width: 50%;
  margin-right: 2%;
}

.header-page2 div:last-child {
  flex-grow: 1;
}

.header {
  display: flex;
  padding: 0px 0;
}

.header div {
  border: 2px solid #000;
  padding: 5px 5px 5px 5px;
}

.header div:nth-of-type(1) {
  width: 40%;
  margin-right: 2%;
}

.header div:last-child {
  flex-grow: 1;
}

.header .header-page2,
.dashed-box,
.footer-receita {
  position: relative;
}

div h1 {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #fff;
  width: fit-content;
  font: bold 19px 'Helvetica';
  line-height: 22px;
}

div h2 {
  position: absolute;
  top: -20px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 0.9em;
  background-color: #fff;
  width: fit-content;
  padding: 0 20px;
}

div h3 {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #fff;
  width: fit-content;
  padding: 0 20px;
  font: bold 16px 'Helvetica';
  line-height: 19px;
}

div p {
  margin: 0;
  padding: 2px;
  font: 11px 'Helvetica';
}

.dashed-box {
  border-top: 1px dashed #000;
}

.dashed-box:nth-of-type(1),
.dashed-box:nth-of-type(2) {
  line-height: 1em;
  display: flex;
  justify-content: flex-start;
  padding-right: 40px;
}

.dashed-box:nth-of-type(1) div:nth-child(2) {
  width: 65%;
}

.dashed-box:nth-of-type(2) div:nth-child(2) {
  width: 70%;
}

.dashed-box:nth-of-type(2) div:nth-child(3) {
  width: 35%;
}

.footer-receita {
  display: flex;
  padding: 10px 0;
}

.footer-receita .card {
  border: 2px solid #000;
  width: 60%;
  text-align: center;
  font-size: 9px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.footer-receita .card:nth-of-type(1) {
  margin-right: 3%;
}

.assinatura {
  width: 90%;
  height: 10px;
  margin: auto;
  border-bottom: 2px solid black;
  position: relative;
  flex-grow: 1;
}

.assinatura p {
  padding: 0;
  margin: 0;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  bottom: -20px;
}

.card-footer-receita {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-right: 10px;
}

.card-footer-receita div {
  margin-top: 15px;
  text-align: left;
  padding: 0 5px;
}

.card-footer-receita p {
  margin: 0;
  padding: 0;
}

.print-p {
  font: 9px;
}
@media print {
  body {
    width: 100%;
    height: 100%;
    font-size: 0.8em;
  }

  .container {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
  }

  .container div {
    padding: 0;
    font-size: 0.7em;
  }

  div h2 {
    top: -12px;
    font-size: 0.9em;
  }

  .footer-receita {
    margin-top: 280px;
  }

  .footer-receita h2 {
    font-size: 0.7em;
  }

  .footer-receita .card {
    font-size: 0.6em;
    padding: 0 0 15px 0;
  }

  .assinatura {
    height: 15px;
  }

  .assinatura p {
    bottom: -10px;
  }
}
</style>